import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";


export interface BlogItem {
    postID: number,
    postTitle: string,
    postDate: string,
    postSlug: string,
    postDesc: string,
    postCont: string,
    publish: boolean
}

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {
    showingTopic: boolean = false;

    constructor(public router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.showingTopic = event.url !== '/blog';
            }
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/blog/blog.component.ts